import { render } from "./login-require.vue?vue&type=template&id=b3b0c0c4"
import script from "./login-require.vue?vue&type=script&lang=js"
export * from "./login-require.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__